if (!customElements.get('navarambh-seven')) {
  customElements.define('navarambh-seven', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }

    init() {
      this.frame = null;
      this.stick = this.querySelector('.nvBox__stick');
      this.lid = this.querySelector('.nvBox__lid');
      this.slots = [...this.querySelectorAll('.nvSlot')];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.onScroll = () => {
        if (this.frame == null) this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.paint();
        });
      };
      this.onResize = () => this.mode();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      this.motion.addEventListener('change', this.onResize);
      this.mode();
      document.fonts?.ready.then(() => { if (this.isConnected) this.mode(); });
    }

    mode() {
      if (!this.stick) return;
      const wantsPin = this.lid && !this.motion.matches && innerWidth >= 901 && innerHeight >= 500;
      this.classList.toggle('is-pinned', Boolean(wantsPin));
      if (wantsPin) {
        const style = getComputedStyle(this.stick);
        const room = this.stick.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
        if (this.stick.firstElementChild.scrollHeight > room - 4) this.classList.remove('is-pinned');
      }
      this.classList.add('is-ready');
      if (this.classList.contains('is-pinned')) {
        this.observer?.disconnect();
        this.observer = null;
        this.classList.remove('is-in');
        this.paint();
      } else {
        this.lid?.style.removeProperty('--lid-y');
        this.lid?.style.removeProperty('--lid-o');
        this.slots.forEach(slot => {
          slot.style.removeProperty('--slot-o');
          slot.style.removeProperty('--slot-y');
          slot.classList.remove('is-lit');
        });
        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-in');
        } else if (!this.classList.contains('is-in') && !this.observer) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.classList.add('is-in');
              this.observer.disconnect();
              this.observer = null;
            }
          }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
          this.observer.observe(this);
        }
      }
    }

    paint() {
      if (!this.classList.contains('is-pinned')) return;
      const rect = this.getBoundingClientRect();
      const range = Math.max(1, rect.height - innerHeight);
      const progress = Math.max(0, Math.min(1, -rect.top / range));
      const lidProgress = Math.min(1, progress / .26);
      this.lid.style.setProperty('--lid-y', `${-lidProgress * 20}%`);
      this.lid.style.setProperty('--lid-o', String(1 - lidProgress));
      this.lid.style.visibility = lidProgress >= 1 ? 'hidden' : 'visible';
      this.slots.forEach((slot, index) => {
        const reveal = Math.max(0, Math.min(1, (progress - (.22 + index * .075)) / .16));
        slot.style.setProperty('--slot-o', String(reveal));
        slot.style.setProperty('--slot-y', `${((1 - reveal) * 26).toFixed(1)}px`);
        slot.classList.toggle('is-lit', reveal > .04);
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.motion?.removeEventListener('change', this.onResize);
    }
  });
}
